<div *ngFor="let noteSection of noteSections">
  <div [ngClass]="noteSection.noteClass" role="alert">
    <i [ngClass]="noteSection.iconClass || ''"></i>
    <strong> {{ noteSection.title }}</strong>
    <div [innerHTML]="noteSection.body | mdToHtml"></div>
  </div>
</div>
